import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import noimage from "../../../assets/Images/no_image_available.jpg";
import { ImageTypeEnum } from "../../../constants/enums/image-type-enum";
import { useStore } from "../../../contexts/store-provider";
import CustomerTopNavbar from "../../../shared-components/navbar/customer-top-navbar";
import StoreAccessInfoTab from "./components/store-access-info-tab";
import StoreIntroductionTab from "./components/store-introduction-tab";
import StoreServicesTab from "./components/store-services-tab";
import StoreStaffTab from "./components/store-staff-tab";
import "./store-details.css";
import RoutesConstants from "../../routes.constant";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";

const StoreDetailPage: React.FC = () => {
  const { storeCmsStore, smrStore } = useStore();
  const { GetCMSImageByStoreIdImageTypeService, allCMSStoreImages,resetcmsStoreImageState, cmsStoreImageState, cmsStoreImage } = smrStore;
  const {
    GetStoreCmsByIdAnonymousService,
    cmsStoreDetails,
    GetStoreCmsStaffsByIdService,
    GetStoreCmsTreatmentsByIdService,
    GetStoreCmsWorkingHoursByIdAnonymousService,
    getWorkingHoursSettingDetail,
    cmsStoreTreatmentState,
    cmsTreatmentList,
    cmsStaffStoreList,
    resetCMSTreatmentList,
    GetStoreDetailsByStoreCodeAnonymousService,
    storeCodeDetails,
    cmsStoreAnonymousState,
    resetCMSStoreAnonymousState,
    resetGetStoreCmsState,
    resetCMSStaffState,
    resetcmsStoreTreatmentState,
    resetcmsStoreWorkingHoursState,
    cmsStoreState,
    cmsStoreStaffState,
    cmsStoreWorkingHoursState,
    resetStoreCodeDetails
  } = storeCmsStore;
  const STAFF_LIST_LIMIT = 4; // Limit for staff list, can be adjusted as needed
  const { storeCode } = useParams<{ storeCode: string }>(); // Extracts "12" from the URL
  const baseURL = "/LizeraStoreDetails/StoreId"; // Base URL for the store details
  const [urlStoreCode, setUrlStoreCode] = useState<string>(storeCode || "");
  const [urlStoreId, setUrlStoreId] = useState<number>(-1);
  const [key, setKey] = useState("details");

  const history = useHistory();

  useEffect(() => {
    if (urlStoreId && urlStoreId > 0) {
      GetStoreCmsByIdAnonymousService(urlStoreId);
      GetStoreCmsStaffsByIdService(urlStoreId);
      GetStoreCmsTreatmentsByIdService(urlStoreId, true);
      GetCMSImageByStoreIdImageTypeService(urlStoreId, ImageTypeEnum.StoreCMS);
      GetStoreCmsWorkingHoursByIdAnonymousService(urlStoreId);
    }
  }, [urlStoreId]);

  useEffect(() => {
    if (storeCodeDetails && storeCodeDetails.Id > 0 && urlStoreCode !== "") {
      setUrlStoreId(storeCodeDetails.Id);  
    }
  }, [storeCodeDetails]);

  useEffect(() => {
    if (storeCodeDetails && storeCodeDetails.Id === 0 && urlStoreCode !== "" && cmsStoreAnonymousState.error) {
      // setUrlStoreId(storeCodeDetails.Id);
      history.push(RoutesConstants.InvalidStore)
    }
  }, [storeCodeDetails, cmsStoreAnonymousState.error]);

  useEffect(() => {
    if (urlStoreCode !== "") {
      GetStoreDetailsByStoreCodeAnonymousService(urlStoreCode);
    }
  }, [urlStoreCode]);

  useEffect(() => {
    if(urlStoreId > 0){
      if (key == "reviews") {
        resetCMSTreatmentList();
        GetStoreCmsTreatmentsByIdService(urlStoreId, false);
      } else if (key == "staff") {
        GetStoreCmsStaffsByIdService(urlStoreId);
      } else if (key == "details") {
        resetCMSTreatmentList();
        GetStoreCmsByIdAnonymousService(urlStoreId);
        GetStoreCmsStaffsByIdService(urlStoreId);
        GetStoreCmsTreatmentsByIdService(urlStoreId, true);
        GetCMSImageByStoreIdImageTypeService(urlStoreId, ImageTypeEnum.StoreCMS);
        GetStoreCmsWorkingHoursByIdAnonymousService(urlStoreId);
      } else {
        GetStoreCmsByIdAnonymousService(urlStoreId);
        GetCMSImageByStoreIdImageTypeService(urlStoreId, ImageTypeEnum.StoreCMS);
        GetStoreCmsWorkingHoursByIdAnonymousService(urlStoreId);
      }
    }
  }, [key]);

  useEffect(()=>{
    return(()=>{
      setUrlStoreId(-1)
      resetStoreCodeDetails();
      resetCMSStoreAnonymousState();
      resetGetStoreCmsState();
      resetCMSStaffState();
      resetcmsStoreTreatmentState();
      resetcmsStoreImageState();
      resetcmsStoreWorkingHoursState();
    })
  }, []);

  return (
    <Container fluid className="store-list-page">
      <CustomerTopNavbar />

      {
        (cmsStoreAnonymousState.inProgress || cmsStoreWorkingHoursState.inProgress || cmsStoreState.inProgress || cmsStoreStaffState.inProgress || cmsStoreTreatmentState.inProgress || cmsStoreImageState.inProgress) &&
        <FormLoader loading={(cmsStoreAnonymousState.inProgress || cmsStoreWorkingHoursState.inProgress || cmsStoreState.inProgress || cmsStoreStaffState.inProgress || cmsStoreTreatmentState.inProgress || cmsStoreImageState.inProgress)} />
      }
      <Container className="store-detail-container pb-4">
        <Tabs
          defaultActiveKey="details"
          activeKey={key}
          onSelect={(k) => setKey(k || "details")}
          className="mb-3 store-header-tabs"
        >
          {/* {JSON.stringify(storeCodeDetails)} */}
          <Tab
            eventKey="details"
            title={
              <>
                <i className="bi bi-house-door-fill"></i>
                <FormattedMessage id="store_introduction" />
              </>
            }
          >
            <StoreIntroductionTab
              limit={STAFF_LIST_LIMIT}
              storeName={cmsStoreDetails?.StoreName}
              desc="string"
              mobileNumber={cmsStoreDetails?.MobileNumber}
              address={cmsStoreDetails?.Address}
              prefectureName={storeCodeDetails.PrefectureName ? storeCodeDetails.PrefectureName : ""}
              accessInformation={cmsStoreDetails?.AccessInformation}
              storeMapURL={cmsStoreDetails?.StoreMapURL}
              storeDetails={cmsStoreDetails}
              staffList={cmsStaffStoreList}
              treatmentList={cmsTreatmentList}
              workingHours={getWorkingHoursSettingDetail}
              images={
                allCMSStoreImages.length > 0
                  ? allCMSStoreImages
                      .map((img) => img.ImageBase64)
                      .filter((img): img is string => typeof img === "string")
                  : [noimage, noimage, noimage, noimage]
              }
              setKey={setKey}
            />
          </Tab>
          <Tab
            eventKey="reviews"
            title={
              <>
                <i className="bi bi-tags-fill"></i>
                <FormattedMessage id="services" />
              </>
            }
          >
            <StoreServicesTab
              treatmentList={cmsTreatmentList}
              storeDetails={cmsStoreDetails}
              storeCode={storeCodeDetails.StoreCode}
            />
          </Tab>

          <Tab
            eventKey="staff"
            title={
              <>
                <i className="bi bi-people-fill"></i>
                <FormattedMessage id="Staff" />
              </>
            }
          >
            <StoreStaffTab
              staffList={cmsStaffStoreList}
              storeDetails={cmsStoreDetails}
            />
          </Tab>

          <Tab
            eventKey="access"
            title={
              <>
                <i className="bi bi-geo-alt-fill"></i>
                <FormattedMessage id="access_information" />
              </>
            }
          >
            <StoreAccessInfoTab
              accessInformation={cmsStoreDetails?.AccessInformation}
              address={cmsStoreDetails?.Address}
              storeMapURL={cmsStoreDetails?.StoreMapURL}
              prefectureName={storeCodeDetails.PrefectureName ? storeCodeDetails.PrefectureName : ""}
            />
          </Tab>
        </Tabs>
      </Container>
    </Container>
  );
};

export default observer(StoreDetailPage);
